"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftTransfersProcessor = void 0;
var SimpleProcessor_1 = require("../common/SimpleProcessor");
var NftTransferDocumentBuilder_1 = require("./NftTransferDocumentBuilder");
var NftTransfersProcessor = /** @class */ (function () {
    function NftTransfersProcessor(collectionNameBuilder) {
        this.collectionNameBuilder = collectionNameBuilder;
        this.simpleProcessor = new SimpleProcessor_1.SimpleProcessor(this.collectionNameBuilder, NftTransferDocumentBuilder_1.NftTransferDocumentBuilder.build);
    }
    NftTransfersProcessor.prototype.process = function (batch) {
        return this.simpleProcessor.process(batch.nftTransfers, batch);
    };
    return NftTransfersProcessor;
}());
exports.NftTransfersProcessor = NftTransfersProcessor;
//# sourceMappingURL=NftTransfersProcessor.js.map